import getSymbolFromCurrency from 'currency-symbol-map';
import { Link } from 'react-router-dom';
import { ml } from 'src/_shared/services/utils.js';

const BaseReferenceCard = ({
	currentUser,
	title,
	allMultiLingualData,
	height,
	referralTotal = 0,
	bonusTotal = 0,
	currency,
}) => {
	if (!currentUser) {
		return null;
	}

	const currencyCode = currency ?? 'USD';
	const hideBonus = currentUser?.company?.hideBonus ?? false;

	return (
		<div className={`d-card ${height === 'height-equal' && 'height-equal'}`}>
			<div className="d-card-head">
				<h4 className="d-title">{title}</h4>
			</div>
			<div className="d-card-body vh-center aaa">
				<div className="justify-data-box">
					{title === ml('Your Referrals', currentUser, allMultiLingualData) && (
						<div
							className="data-card dark-text bg-ffffff"
							style={
								hideBonus &&
								title === ml('Your Referrals', currentUser, allMultiLingualData)
									? { maxWidth: 'none' }
									: {}
							}
						>
							{referralTotal >= 1 ? (
								<>
									<h5>
										<Link to="/myreferrals" className="font-weight-bold">
											{referralTotal.toLocaleString()}
										</Link>
									</h5>
									<p>{ml('Referrals', currentUser, allMultiLingualData)}</p>
								</>
							) : (
								<>
									<h5>0</h5>
									<p>
										<Link to="/browsejobs">
											{ml('Click Here', currentUser, allMultiLingualData)}
										</Link>{' '}
										{ml(
											'to make your first referral',
											currentUser,
											allMultiLingualData
										)}
									</p>
								</>
							)}
						</div>
					)}
					{!hideBonus &&
					title === ml('Your Referrals', currentUser, allMultiLingualData) ? (
						<div className="data-card light-text bg-6CB761">
							<h5>
								{getSymbolFromCurrency(currencyCode)}
								{bonusTotal.toLocaleString()}
							</h5>
							<p>{ml('Total Bonuses', currentUser, allMultiLingualData)}</p>
						</div>
					) : null}
				</div>
			</div>
		</div>
	);
};

export const ReferralCard = BaseReferenceCard;
